/* Catalog toolbar behaviour: search, "Starting" chips, active-filter pills,
   result count, empty state. Markup in snippets/nvwa-toolbar.liquid.

   Loaded with `defer` on purpose. The toolbar renders ABOVE the grid, so an
   inline script would execute before the grid exists in the DOM and find
   nothing to filter. defer guarantees the document is parsed first.

   WHY "STARTING" IS CLIENT-SIDE: Shopify cannot facet on a variant date
   metafield range -- the same wall that killed the step 3b Flow. This reads the
   data-next-start attribute nvwa-course-date.liquid already emits, so the
   chips, the card copy and the "Starting soonest" sort agree by construction.
   Limitation: it filters the RENDERED page, which is sound while
   products_per_page (50) exceeds the collection size (46).

   4 Sep 2026. Two changes after Christian reported the chips "do nothing" and
   asked to see applied filters on the page:
     - The chips were working. They set `hidden` on the cards that did not
       match, and a `display:flex` rule in nvwa-custom.css outranked
       [hidden]{display:none} so the browser kept painting all 46. Fixed in the
       stylesheet, not here -- see the "[hidden] MUST WIN" block there.
     - The pill row now covers the theme's server-side facets as well as the
       search box and the chips, each removable on its own, with a real
       clear-all button. See paintPills and dropFacet. */
(function () {
  'use strict';

  var tb = document.getElementById('NvwaToolbar');
  if (!tb) { return; }

  var search = document.getElementById('NvwaSearch');
  var countEl = document.getElementById('NvwaCount');
  var pillsEl = document.getElementById('NvwaPills');
  var chips = Array.prototype.slice.call(tb.querySelectorAll('[data-start]'));

  var state = { q: '', starts: [] };
  var LABEL = {};
  chips.forEach(function (c) { LABEL[c.getAttribute('data-start')] = c.textContent.trim(); });

  function grid() { return document.querySelector('.collection-grid'); }
  function cards() {
    var g = grid();
    return g ? Array.prototype.slice.call(g.querySelectorAll('.grid-item')) : [];
  }

  /* Midnight today, so a cohort starting today is bucketed the way the card
     describes it rather than drifting with the time of day. */
  function today() { var d = new Date(); d.setHours(0, 0, 0, 0); return d; }

  function bucketsFor(iso) {
    if (!iso) { return ['any']; }
    var d = new Date(iso + 'T00:00:00');
    if (isNaN(d.getTime())) { return ['any']; }
    var days = Math.round((d - today()) / 864e5);
    var out = [];
    if (days >= 0 && days <= 30) { out.push('30'); }
    if (days >= 0 && days <= 92) { out.push('90'); }
    if (d.getFullYear() <= 2026) { out.push('2026'); }
    if (d.getFullYear() === 2027) { out.push('2027'); }
    return out;
  }

  /* Cached per element. Cleared on collection:reloaded, because ajax filtering
     replaces the cards with new elements. */
  var hay = new WeakMap();
  function haystack(card) {
    var v = hay.get(card);
    if (v === undefined) {
      v = (card.innerText || '').replace(/\s+/g, ' ').toLowerCase();
      hay.set(card, v);
    }
    return v;
  }

  /* The theme's server-side facet values. Names and values come from the
     sidebar copy of the facet form -- the source of truth the theme itself
     clones, always in the DOM even though the filter drawer hides it with CSS,
     which is exactly why the drawer hides it rather than removing it. The
     human-readable label comes from the same row's .tag__text. */
  function facets() {
    return Array.prototype.slice.call(
      document.querySelectorAll('#CollectionSidebarFilterWrap input.tag__input:checked')
    ).map(function (input) {
      var label = input.closest('label');
      var text = label ? label.querySelector('.tag__text') : null;
      return {
        name: input.name,
        value: input.value,
        label: (text ? text.textContent : input.value).replace(/\s+/g, ' ').trim()
      };
    });
  }

  /* WHY FACET CHANGES ARE MADE ON THE URL AND NOT BY TOGGLING CHECKBOXES.
     The obvious implementation -- uncheck the inputs, fire one `input` event,
     let the theme serialise the form -- is what the first version did, and it
     dropped filters unreliably: after applying Subject then Level, "clear all"
     came back with Level still applied. Instrumenting theme.AjaxRenderer showed
     renderPage being called with an EMPTY parameter string, exactly as
     intended, and the URL still ending up with the last-applied facet. The
     survivor was always the most recently applied one, which is the signature
     of the previous in-flight render resolving after this one and overwriting
     it -- the theme's isAnimating guard does not cover that ordering.

     Rebuilding the query string and handing it straight to the theme's own
     renderer removes the ambiguity: no FormData, no dependence on which copy of
     an input is checked, and the request states precisely what it wants.
     renderCollectionPage is the same method the theme's own facet path calls,
     so ajax, history and the re-render all behave identically.

     ...with ONE exception, and it is a bug in the theme's bundled AjaxRenderer,
     not here. It does not clear MORE THAN ONE filter parameter in a single
     render. Measured with the renderer instrumented, nothing else in flight
     (isAnimating false) and the parameter set verified empty first:

       url before   ?filter.p.m.custom.subject=Wine&filter.p.m.custom.level=Level+2
       renderPage   params: ""   (empty, as intended)
       url after    ?filter.p.m.custom.level=Level+2

     One survivor, always the last applied -- the signature of deleting keys
     while iterating them. Removing a SINGLE parameter is reliable: 2 -> 1 and
     1 -> 0 were both verified clean. So anything dropping more than one
     parameter navigates instead. A reload for "clear all" costs a page load
     and cannot come back half-applied, which is the right trade for the one
     control a shopper uses to undo a mistake. ajax-renderer is a bundled npm
     module, so fixing it at source is not available here. */
  function renderParams(params, navigate) {
    /* 8 Sep 2026. The browse band prints Shopify's own filter_value.count on
       every tile, ABOVE the grid and OUTSIDE the ajax container. An ajax
       render would leave those numbers -- and the highlighted tiles -- showing
       the state before the change, so a shopper removing a pill would be
       looking at a control that contradicts the results under it. Stale counts
       are worse than a page load, which is also why a tile is a plain link.
       With the band absent this is unchanged and facet edits stay on ajax. */
    if (document.querySelector('[data-nvl-browse]')) { navigate = true; }

    var host = document.querySelector('collection-template');
    if (!navigate && host && typeof host.renderCollectionPage === 'function') {
      host.renderCollectionPage(params);
      return;
    }
    /* Also the path when there is no custom element at all -- script blocked,
       or hydration never ran. */
    var qs = params.toString();
    window.location.search = qs ? '?' + qs : '';
  }

  function dropFacet(name, value) {
    var params = new URLSearchParams(window.location.search);
    var keep = params.getAll(name).filter(function (v) { return v !== value; });
    params.delete(name);
    keep.forEach(function (v) { params.append(name, v); });
    renderParams(params, false);
  }

  function dropAllFacets() {
    var params = new URLSearchParams(window.location.search);
    var doomed = [];
    params.forEach(function (v, k) { if (k.indexOf('filter.') === 0) { doomed.push(k); } });
    if (!doomed.length) { return false; }
    doomed.forEach(function (k) { params.delete(k); });
    renderParams(params, doomed.length > 1);
    return true;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function apply() {
    var g = grid();
    if (!g) { return; }
    var all = cards();
    var q = state.q.trim().toLowerCase();
    var shown = 0;

    all.forEach(function (card) {
      var ok = true;
      if (q && haystack(card).indexOf(q) === -1) { ok = false; }
      if (ok && state.starts.length) {
        var n = card.querySelector('[data-next-start]');
        var b = bucketsFor(n ? n.getAttribute('data-next-start') : null);
        ok = state.starts.some(function (s) { return b.indexOf(s) !== -1; });
      }
      card.hidden = !ok;
      if (ok) { shown++; }
    });

    /* The member strip is an ad, not a result, so it has no business sitting in
       a filtered list -- the same rule the server-side render already follows. */
    var strip = g.querySelector('.memberstrip');
    if (strip) { strip.hidden = (q !== '' || state.starts.length > 0); }

    paintCount(shown, all.length);
    paintPills();
    paintEmpty(shown);
  }

  function paintCount(shown, total) {
    if (!countEl) { return; }
    var grand = parseInt(tb.getAttribute('data-total'), 10) || total;
    countEl.innerHTML = (shown === total && shown === grand)
      ? 'Showing <b>' + shown + '</b> courses &amp; trips'
      : 'Showing <b>' + shown + '</b> of <b>' + grand + '</b>';
  }

  function pill(key, label) {
    return '<span class="nvtb__pill">' + label +
      '<button type="button" aria-label="Remove filter" data-nv-remove="' + key + '">×</button></span>';
  }

  /* One pill per applied filter, whichever mechanism it came from. Facets are
     listed first because they are the ones a shopper set deliberately in the
     drawer and cannot otherwise see from the page. */
  function paintPills() {
    if (!pillsEl) { return; }
    var html = '';
    facets().forEach(function (f) {
      html += pill(
        'facet:' + encodeURIComponent(f.name) + '|' + encodeURIComponent(f.value),
        esc(f.label)
      );
    });
    if (state.q.trim()) { html += pill('q', '“' + esc(state.q.trim()) + '”'); }
    state.starts.forEach(function (s) { html += pill('start:' + s, esc(LABEL[s])); });
    chips.forEach(function (c) {
      c.classList.toggle('is-on', state.starts.indexOf(c.getAttribute('data-start')) !== -1);
      c.setAttribute('aria-pressed', state.starts.indexOf(c.getAttribute('data-start')) !== -1 ? 'true' : 'false');
    });
    if (html) {
      pillsEl.innerHTML =
        '<span class="nvtb__pills-lbl">Filtering by</span>' + html +
        '<button type="button" class="nvtb__clear" data-nv-clear>Clear all filters</button>';
      pillsEl.hidden = false;
    } else {
      pillsEl.innerHTML = '';
      pillsEl.hidden = true;
    }
  }

  function paintEmpty(shown) {
    var g = grid();
    var el = document.getElementById('NvwaEmpty');
    if (!el) {
      var tpl = document.getElementById('NvwaEmptyTpl');
      if (!tpl || !g) { return; }
      el = tpl.content.firstElementChild.cloneNode(true);
      g.parentNode.insertBefore(el, g.nextSibling);
    }
    el.hidden = shown !== 0;
    if (shown !== 0) { return; }

    /* Name the filter doing the damage rather than shrugging at the shopper. */
    var msg = document.getElementById('NvwaEmptyMsg');
    if (!msg) { return; }
    var culprit = null;
    if (state.q.trim() && state.starts.length === 0) { culprit = 'that search'; }
    else if (!state.q.trim() && state.starts.length === 1) { culprit = '“' + LABEL[state.starts[0]] + '”'; }
    msg.innerHTML = culprit
      ? 'Nothing here matches ' + esc(culprit) + '. Try widening it — most combinations of level and format have only a handful of cohorts.'
      : 'Try widening one of them — most combinations of level and format have only a handful of cohorts.';
  }

  function clearAll() {
    state.q = '';
    state.starts = [];
    if (search) { search.value = ''; }

    /* "Clear all" has to drop the theme's server-side facets too -- that is what
       a shopper means by it. Strip every filter.* parameter in one request; see
       the note on renderParams for why this is done on the URL rather than by
       unchecking inputs. */
    if (dropAllFacets()) { return; }
    apply();
  }

  var qt;
  if (search) {
    search.addEventListener('input', function (e) {
      var v = e.target.value;
      clearTimeout(qt);
      qt = setTimeout(function () { state.q = v; apply(); }, 160);
    });
  }

  tb.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-start]');
    if (chip) {
      var k = chip.getAttribute('data-start');
      var i = state.starts.indexOf(k);
      if (i === -1) { state.starts.push(k); } else { state.starts.splice(i, 1); }
      apply();
      return;
    }
    var rm = e.target.closest('[data-nv-remove]');
    if (rm) {
      var key = rm.getAttribute('data-nv-remove');
      if (key.indexOf('facet:') === 0) {
        /* Server-side: hand it to the theme and let collection:reloaded repaint.
           Do not call apply() here -- the grid has not been replaced yet. */
        var parts = key.slice(6).split('|');
        dropFacet(decodeURIComponent(parts[0]), decodeURIComponent(parts[1] || ''));
        return;
      }
      if (key === 'q') { state.q = ''; if (search) { search.value = ''; } }
      else if (key.indexOf('start:') === 0) {
        var s = key.slice(6);
        var j = state.starts.indexOf(s);
        if (j !== -1) { state.starts.splice(j, 1); }
      }
      apply();
      return;
    }
    if (e.target.closest('[data-nv-clear]')) { clearAll(); }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('#NvwaClearAll')) { clearAll(); }
  });

  document.addEventListener('collection:reloaded', function () {
    hay = new WeakMap();
    apply();
  });

  apply();
})();
